import LockTableCellRenderer from "./LockTableCellRenderer";

export default class EmptyCellRenderer extends LockTableCellRenderer {
    generateContent(cell) {
    }

    updateUI(cell) {
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/renderers/EmptyCellRenderer.js